import { render, staticRenderFns } from "./description_detail.vue?vue&type=template&id=ef79e74e&scoped=true&"
import script from "./description_detail.vue?vue&type=script&lang=js&"
export * from "./description_detail.vue?vue&type=script&lang=js&"
import style0 from "./description_detail.vue?vue&type=style&index=0&id=ef79e74e&lang=less&scoped=true&"
import style1 from "./description_detail.vue?vue&type=style&index=1&id=ef79e74e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef79e74e",
  null
  
)

export default component.exports